import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../lib/api.js";
import { TgHeader } from "../components/ui/index.js";
import { FlexOrderDetail, type FlexOrderRow } from "./FlexOrderDetail.js";
import { type Order } from "@mnp/shared";

// @marknpost — менеджер (юзер), не клиентский бот. Тот же контакт, что в
// FlexOrderDetail.onContactManager.
function contactManager() {
  const link = "https://t.me/marknpost";
  const tg = (window as any).Telegram?.WebApp;
  if (tg?.openTelegramLink) tg.openTelegramLink(link);
  else window.open(link, "_blank", "noopener,noreferrer");
}

// Детальный экран заказа. Единственное живое направление в Mini App — flex
// (делегируется в FlexOrderDetail). Ozon/WB-ветки удалены: модуль в архиве
// (ветка archive/ozonwb-flow, тег pre-ozonwb-extract); для не-flex direction
// показываем нейтральный fallback.
export function OrderDetailScreen() {
  const { id } = useParams<{ id: string }>();
  const nav = useNavigate();
  const { data, isLoading, error } = useQuery({
    queryKey: ["order", id],
    queryFn: () => api<Order>(`/orders/${id}`),
    enabled: !!id,
  });

  if (!id) return null;

  if (isLoading) {
    return (
      <div className="app-shell">
        <TgHeader title="Заказ" onBack={() => nav("/orders")} />
        <div className="screen pad">
          <p className="t-body">Загрузка…</p>
        </div>
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="app-shell">
        <TgHeader title="Заказ" onBack={() => nav("/orders")} />
        <div className="screen pad">
          <p className="t-body">Не удалось загрузить заказ</p>
          <button
            className="btn btn-secondary"
            onClick={() => nav("/orders")}
            style={{ marginTop: 12 }}
          >
            К списку заказов
          </button>
        </div>
      </div>
    );
  }

  // Flex parcel branch — completely separate layout (O2). The FlexOrderDetail
  // component fetches the full record via /parcel-requests/:id (includes all
  // flex* fields + statusLog), passing what we already have as initial data
  // so the screen renders instantly.
  if (data.direction === "flex") {
    return <FlexOrderDetail fallback={data as unknown as FlexOrderRow} />;
  }

  // Non-flex (легаси Ozon/WB) — клиентского UI больше нет.
  return (
    <div className="app-shell">
      <TgHeader title="Заказ" onBack={() => nav("/orders")} />
      <div className="screen pad">
        <p className="t-body" data-testid="order-unavailable">
          Заказ недоступен
        </p>
        <p className="t-small" style={{ color: "var(--mnp-fg-3)" }}>
          Это направление сейчас не обслуживается в приложении. Если у вас
          остались вопросы по заказу — напишите менеджеру.
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 12 }}>
          <button className="btn btn-primary" onClick={contactManager}>
            Написать менеджеру
          </button>
          <button className="btn btn-secondary" onClick={() => nav("/orders")}>
            К списку заказов
          </button>
        </div>
      </div>
    </div>
  );
}
